export class InventoryItemDTO {
  id: string = "";
  hasBacklitKeyboard: boolean = false;
  hasFingerprintReader: boolean = false;
  hasPrivacyScreen: boolean = false;
  hasStylus: boolean = false;
  cpuModel: string = "";
  diskDriveSize: number = 0;
  diskDriveUnit: string = "";
  diskDriveType: string = "";
  hasTouchscreen: boolean = false;
  imageLargeLocation: string = "";
  isEducation: boolean = false;
  isChromeX: boolean = false;
  isParallelsCapable: boolean = false;
  listPrice: number = 0;
  locality: string = "";
  manufactureName: string = "";
  manufacturePart: string = "";
  materialID: string = "";
  memorySize: number = 0;
  memoryUnit: string = "";
  name: string = "";
  productDescLong: string = "";
  productDescShort: string = "";
  productLine: string = "";
  productType: string = "";
  formattedScreenSize: string = "";
  screenSize: number = 0;
  showInResults: boolean = true;
  vendorURL: string = "";
  isInStock: boolean = false;

  constructor() {}
}
